import { create } from 'zustand';
import { HttpRequestError } from '../types';

interface ErrorState {
  httpError?: HttpRequestError;
  setHttpError: (error: HttpRequestError) => void;
  clearHttpError: () => void;
}

export const useErrorStore = create<ErrorState>()(set => ({
  httpError: undefined,
  setHttpError: httpError => set({ httpError }),
  clearHttpError: () => set({ httpError: undefined }),
}));
